import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { tap, catchError, EMPTY, finalize } from 'rxjs';
import { BasicResult } from 'src/app/core-module/models/basic-result';
import { CAQuestion } from 'src/app/core-module/models/ExternalAudits/ca-question';
import { CAResult } from 'src/app/core-module/models/ExternalAudits/ca-result';
import { Toastr } from 'src/app/core-module/models/Utils/toastr';
import { ExternalAuditsService } from 'src/app/core-module/services/external-audits.service';
import { ToastrService } from 'src/app/core-module/services/toastr.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-public-audit',
  templateUrl: './public-audit.component.html',
  styleUrl: './public-audit.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PublicAuditComponent {

  //Page variables
  public GUIDKey: string = "";
  public auditResult: CAResult = new CAResult();
  public currentQuestion: CAQuestion = new CAQuestion();
  public pageCount: number = 0;
  public currentPageCount: number = 0;
  public CampaignLink: boolean = false;

  //Page display switches
  public isLoading: boolean = true;
  public invalidAudit: boolean = false;
  public auditCompleted: boolean = false;
  public somethingWrong: boolean = false;
  public displayAuditStart: boolean = false;
  public displayAudit: boolean = false;
  public displaySubmitting: boolean = false;
  public displaySummary: boolean = false;

  //Subpage helpers
  public firstQuestion: boolean = false;
  public lastQuestion: boolean = false;

  public isBluebird: boolean = false;



  constructor(private route: ActivatedRoute, private auditService: ExternalAuditsService, private toastr: ToastrService) {
    this.isLoading = true;
    if (this.route.snapshot.queryParamMap.get('key') != undefined) {
      this.GUIDKey = this.route.snapshot.queryParamMap.get('key')!
      this.fetchAudit();
    }
    if (this.route.snapshot.queryParamMap.get('link') != undefined) {
      this.CampaignLink = true;
      this.GUIDKey = this.route.snapshot.queryParamMap.get('link')!
      this.fetchAudit();
    }
    if (environment.blueBird) {
      this.isBluebird = true;
    }
  }
  fetchAudit() {
    this.isLoading = true;
    this.auditService.getExternalAudit(this.GUIDKey,this.CampaignLink).pipe(tap((res: CAResult) => {
      if (res.IsError) {
        if (res.ErrorCode == 'EASA001') {
          this.invalidAudit = true;
        } else {
          this.somethingWrong = true;
          this.toastr.addToastr(new Toastr({ Message: "An error occurred, please try again later.", Type: 1 }))
        }
      } else {
        if (res.Audit.Completed) {
          this.auditCompleted = true;
        } else {
          this.auditResult = new CAResult(res);
          this.setGUIDs();
          this.currentQuestion = this.auditResult.Audit.Questions[0];
          this.currentPageCount = 1;
          this.pageCount = this.auditResult.Audit.Questions.length;
          this.displayAuditStart = true;
        }
      }

    }), catchError((err: any, n: any) => {
      this.somethingWrong = true;
      this.toastr.addToastr(new Toastr({ Message: "An error occurred, please try again later.", Type: 1 }))
      return EMPTY;
    }), finalize(() => {
      this.isLoading = false;
    })).subscribe();
  }
  setGUIDs() {
    this.auditResult.Audit.Questions.forEach(x => {
      x.GUID = crypto.randomUUID();
    })
  }
  startAudit() {
    this.displayAuditStart = false;
    this.displayAudit = true;
  }
  hasCustomerLogo() {
    if (this.auditResult.Audit == undefined) {
      return false;
    } else {
      if (this.auditResult.Audit.CustomerLogoURL == undefined) {
        return false;
      } else {
        if (this.auditResult.Audit.CustomerLogoURL.length == 0) {
          return false;
        } else {
          return true;
        }
      }
    }

  }

  nextQuestion() {
    this.resetQuestionHelpers();
    this.currentQuestion.HasViewed = true;
    var currentIndex = this.auditResult.Audit.Questions.findIndex(x => x.QuestionID == this.currentQuestion.QuestionID);
    if (currentIndex != -1) {
      if (currentIndex < this.pageCount - 1) {

        this.currentQuestion = this.auditResult.Audit.Questions[currentIndex + 1];
        if (this.currentQuestion.QuestionTypeID == 6) {
          this.currentQuestion.IsAnswered = true;
        }
        this.currentPageCount++;
        if (currentIndex == this.auditResult.Audit.Questions.length - 2) {
          this.lastQuestion = true;
        }
      } else {
        this.displayAudit = false;
        this.displaySubmitting = true;
        this.lastQuestion = true;
        this.sumbitAudit();
        return;

      }

    }

  }
  sumbitAudit() {
    this.auditResult.Audit.GUIDKey = this.GUIDKey;
    this.auditResult.Audit.IsLink = this.CampaignLink;
    this.auditService.saveExternalAudit(this.auditResult).pipe(tap((res: BasicResult) => {
      if (res.IsError) {
        this.toastr.addToastr(new Toastr({ Message: "An error occurred, please try again later.", Type: 1 }));
        this.displaySubmitting = false;
        this.displayAudit = true;
      } else {
        this.displaySubmitting = false;
        this.displaySummary = true;
      }
    }), catchError((err: any, n: any) => {
      //this.somethingWrong = true;
      this.toastr.addToastr(new Toastr({ Message: "An error occurred, please try again later.", Type: 1 }));
      this.displaySubmitting = false;
      this.displayAudit = true;
      return EMPTY;
    })).subscribe()
  }
  previousQuestion() {
    this.resetQuestionHelpers();
    var currentIndex = this.auditResult.Audit.Questions.findIndex(x => x.QuestionID == this.currentQuestion.QuestionID);
    if (currentIndex != -1) {
      if (currentIndex > 0) {
        this.currentQuestion = this.auditResult.Audit.Questions[currentIndex - 1];
        this.currentPageCount--;
        if (currentIndex == 1) {
          this.firstQuestion = true;
        }
      }

    }
  }
  resetQuestionHelpers() { this.firstQuestion = false; this.lastQuestion = false; }

}
